<script setup lang="ts">
import { MediaRemoteVideo, ParagraphTimelineItem } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphTimelineItem
  counter?: number
}>()

const emits = defineEmits<{
  (e: 'clicked', value: { entity: any }): void
  (e: 'clickedMedia', value: string): void
}>()

const hover = ref(false)

const onHoverHandler = (value: boolean) => {
  hover.value = value
}

const { iframeSrc: overlayVideoUrl } = useModalVideo(
  (props.entity?.fieldVideo?.entity as MediaRemoteVideo)?.fieldMediaOembedVideo || '',
)

const fieldItemClick = (event: MouseEvent) => {
  event.stopPropagation()
  emits('clicked', { entity: props.entity })
}

const clickedMediaHandler = (value: any) => {
  emits('clickedMedia', overlayVideoUrl.value || '')
}

const odd = computed(() => {
  let counter = 0
  counter = props.counter ? props.counter : 0
  return (counter + 1) % 2 === 0 ? true : false
})
</script>

<template>
  <div class="timeline-fielditem-container">
    <div class="empty-container" />
    <TimelineVideoCounter
      v-if="overlayVideoUrl"
      :entity="entity?.fieldVideo?.entity as MediaRemoteVideo"
      @clicked-media="clickedMediaHandler"
    />
    <TimelineRegularCounter
      v-else
      :counter="counter || 0"
      :class="{ 'hover-counter-container': hover }"
      @click="fieldItemClick($event)"
      @mouseover="onHoverHandler(true)"
      @mouseout="onHoverHandler(false)"
    />
    <div
      class="timeline-field-info-container"
      :class="{ 'odd-item': odd, 'even-item': !odd }"
      @click="fieldItemClick($event)"
      @mouseover="onHoverHandler(true)"
      @mouseout="onHoverHandler(false)"
    >
      <div class="timeline-field-description">
        <h3>{{ entity.fieldTitle }}</h3>
        <div v-html="entity.fieldDescription?.processed" />
        <Button icon="mini-plus-small" slide>{{ entity.fieldOverlayTriggerLabel }}</Button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.timeline-fielditem-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  @include breakpoint(tl) {
    &::after {
      content: '';
      top: 40px;
      height: 100%;
      width: 1px;
      background-color: rgba(24, 36, 111, 0.25);
      left: 50%;
      z-index: 0;
      position: absolute;
    }
  }
}
.empty-container {
  flex-basis: calc(50% - 137px);
  flex-shrink: 1;
}
.timeline-field-info-container {
  cursor: pointer;
  padding-top: 20px;
  flex-basis: calc(50% - 137px);
  flex-shrink: 1;
  display: flex;
  position: relative;
  padding-top: 24px;
  .timeline-field-description {
    width: 100%;
    text-align: center;
  }
  @include breakpoint(tl) {
    padding-top: 0;
    .timeline-field-description {
      width: 100%;
      text-align: unset;
      padding-top: 100px;
    }

    &.even-item {
      justify-content: flex-end;
      padding-right: 75px;
      text-align: right;
    }
    &.odd-item {
      justify-content: flex-start;
      padding-left: 75px;
    }
  }
}
</style>
